export default "__VITE_ASSET__Cv0ej0ll__"